let pending: Promise<void> | null = null

export const getSessionPending = () => pending

// Marks a session establishment as in-flight so that concurrent API requests
// can wait for the token instead of going out unauthorized. The gate is set
// synchronously, before `establishSession` reaches its first await.
export const runWithSession = <T>(establishSession: () => Promise<T>): Promise<T> => {
  const running = establishSession()
  const gate = running.then(() => undefined)
  const clear = () => {
    if (pending === gate) {
      pending = null
    }
  }
  void gate.then(clear, clear)
  pending = gate
  return running
}
